import React from 'react';
import './AnimatedLogo.css';

const AnimatedLogo = ({ size = 120 }) => {
  return (
    <div className="animated-logo-container" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="broGradAnim" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#FF5722', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#F4511E', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        
        {/* Background circle */}
        <circle cx="60" cy="60" r="60" fill="url(#broGradAnim)"/>
        
        {/* Left fist - slides in from left */}
        <g className="left-fist">
          <path d="M 38 60 L 38 50 Q 38 45 42 45 L 46 45 Q 50 45 50 50 L 50 60 Z" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="2"/>
          <rect x="34" y="60" width="20" height="22" rx="2" fill="#FFFFFF"/>
          <circle cx="44" cy="66" r="2" fill="#FF5722"/>
          <circle cx="44" cy="72" r="2" fill="#FF5722"/>
        </g>
        
        {/* Right fist - slides in from right */}
        <g className="right-fist">
          <path d="M 82 60 L 82 50 Q 82 45 78 45 L 74 45 Q 70 45 70 50 L 70 60 Z" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="2"/>
          <rect x="66" y="60" width="20" height="22" rx="2" fill="#FFFFFF"/>
          <circle cx="76" cy="66" r="2" fill="#FF5722"/>
          <circle cx="76" cy="72" r="2" fill="#FF5722"/>
        </g>
        
        {/* Impact sparks - appear on collision */}
        <g className="impact-sparks">
          <circle cx="60" cy="55" r="3" fill="#FFFFFF"/>
          <line x1="60" y1="45" x2="60" y2="52" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"/>
          <line x1="52" y1="52" x2="56" y2="56" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"/>
          <line x1="68" y1="52" x2="64" y2="56" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"/>
          <line x1="50" y1="60" x2="56" y2="60" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"/>
          <line x1="70" y1="60" x2="64" y2="60" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"/>
        </g>
        
        {/* Clock - fades in after explosion */}
        <g className="clock-face">
          <circle cx="60" cy="60" r="35" fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round"/>
          \n          {/* Hour hand */}
          <line x1="60" y1="60" x2="60" y2="38" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" className="hour-hand"/>
          \n          {/* Minute hand */}
          <line x1="60" y1="60" x2="78" y2="60" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round\" className="minute-hand"/>
          \n          {/* Center dot */}
          <circle cx="60" cy="60" r="4" fill="#FFFFFF"/>
          \n          {/* Clock dots at 12, 3, 6, 9 */}
          <circle cx="60" cy="22" r="2.5" fill="#FFFFFF" opacity="0.8"/>
          <circle cx="98" cy="60" r="2.5" fill="#FFFFFF" opacity="0.8"/>
          <circle cx="60" cy="98" r="2.5" fill="#FFFFFF" opacity="0.8"/>
          <circle cx="22" cy="60" r="2.5" fill="#FFFFFF" opacity="0.8"/>
        </g>
      </svg>
    </div>
  );
};

export default AnimatedLogo;
